type Primitive = string | number | boolean | null | undefined;

/**
 * Creates a union type of all possible paths in an object type
 */
type FieldPaths<T> = T extends Primitive
  ? never
  : T extends any[]
    ? keyof T extends string
      ? keyof T
      : never
    : keyof T extends string
      ? {
          [K in keyof T & string]:
            | K
            | (T[K] extends Primitive
                ? never
                : T[K] extends any[]
                  ? `${K}` | `${K}.${keyof T[K] & string}`
                  : `${K}.${FieldPaths<T[K]>}`);
        }[keyof T & string]
      : never;

/**
 * Type for field mask that can be either a single field path or array of field paths
 */
export type FieldMask<T> = FieldPaths<T> | FieldPaths<T>[];

/**
 * Helper function to create a field mask from paths
 * @param mask Field mask paths
 * @returns Field mask paths as comma-separated string
 */
export function fieldMask<T>(mask: FieldMask<T>): string {
  return Array.isArray(mask) ? mask.join(',') : mask;
}
